"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placePageReducer = void 0;
var BreadcrumbReducer_1 = require("@/pages/search/reducers/BreadcrumbReducer");
var RecaptureReducer_1 = require("@/pages/search/reducers/RecaptureReducer");
var TestimonialsState_init_1 = require("@/pages/common/states/TestimonialsState.init");
var SfavReducer_1 = require("@/pages/search/reducers/SfavReducer");
exports.placePageReducer = {
    place: function (state) { return state; },
    breadcrumb: BreadcrumbReducer_1.breadcrumbReducer,
    recapture: RecaptureReducer_1.recaptureReducer,
    testimonials: function (state) {
        if (state === void 0) { state = TestimonialsState_init_1.defaultTestimonialsState; }
        return state;
    },
    sfav: SfavReducer_1.sFavReducer,
};
